import { fetchMISTableOptions, fetchAuditedTableData } from '../../store/company/service';
import { getTimeStamp } from '../../utils/dateUtils';

export const pickData = (res: PromiseSettledResult<any>): any => (res.status === 'fulfilled' ? res.value?.data ?? null : null);

export const pickError = (res: PromiseSettledResult<any>): string | undefined =>
    res.status === 'rejected' ? res.reason?.response?.data?.message || res.reason?.message || 'Request failed' : undefined;

export function findMisOptionsArray(node: any, depth = 0): any[] | null {
    if (!node || depth > 6) return null;
    if (Array.isArray(node)) {
        if (node.some((b: any) => Array.isArray(b?.misOptions))) return node;
        return null;
    }
    if (typeof node !== 'object') return null;
    for (const v of Object.values(node)) {
        const found = findMisOptionsArray(v, depth + 1);
        if (found) return found;
    }
    return null;
}

export async function fetchStatementSlices(orgId: string, source: string, type: string, optionsType?: string) {
    let optionsRes: any;
    try {
        optionsRes = await fetchMISTableOptions(optionsType ? { orgId, source, type: optionsType } : { orgId, source });
    } catch {
        return undefined;
    }
    const optionsArray = findMisOptionsArray(optionsRes?.data) ?? [];
    const misOptionsBlock = optionsArray.find((b: any) => Array.isArray(b?.misOptions));
    const misOptions: any[] = misOptionsBlock?.misOptions ?? [];
    const consolidationBlock = optionsArray.find((b: any) => b?.hasConsolidated !== undefined || b?.hasStandalone !== undefined);
    const enabled = misOptions.filter((o: any) => o?.misDisplayName && o?.isDataAvailable !== false);
    if (enabled.length === 0) return undefined;
    const settled = await Promise.allSettled(
        enabled.map((o: any) =>
            fetchAuditedTableData({
                orgId,
                requestId: getTimeStamp(),
                type,
                mis: o.misDisplayName,
                raw: false,
            }),
        ),
    );
    const slices = settled
        .map((r, i) => {
            if (r.status !== 'fulfilled') return null;
            const payload = r.value?.data ?? null;
            return payload ? { name: enabled[i].misDisplayName, payload } : null;
        })
        .filter(Boolean);
    if (slices.length === 0) return undefined;
    return {
        slices,
        hasStandalone: consolidationBlock?.hasStandalone === true,
        hasConsolidated: consolidationBlock?.hasConsolidated === true,
    };
}
